import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {
  AppDocumentTypeCategory
} from '../../../../../../../../../_base-shared/models/Document/AppDocumentTypeCategory';
import { AiVisionResult } from '../../../../../../../../../_base-shared/models/File/AiVisionResult';
import { SharedModule } from '../../../../../../_shared/shared.module';
import { DocumentTypeService } from '../../../../../document/document-type.service';


@Component({
  selector   : 'app-ai-vision-modal',
  imports    : [SharedModule],
  templateUrl: './ai-vision-modal.component.html',
  standalone : true,
  styleUrl   : './ai-vision-modal.component.scss'
})
export class AiVisionModalComponent implements OnInit {
  public isLoading                                                  = 0;
  public aiVisionResult: AiVisionResult;
  public type: 'recommendation' | 'summary';
  public fileCategory: AppDocumentTypeCategory;
  public caseId: number;
  public caseUUID: string;
  public caseDocumentTypeCategories: Array<AppDocumentTypeCategory> = [];
  protected subscriptions: Array<Subscription>                      = [];

  constructor(
    private toast: ToastrService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<AiVisionModalComponent>,
    protected documentTypeService: DocumentTypeService,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: 'recommendation' | 'summary',
      aiVisionResult: AiVisionResult,
      caseId: number
      caseUUID: string
    }) {
    this.type           = this.data.type;
    this.aiVisionResult = this.data.aiVisionResult;
    this.caseId         = this.data.caseId;
    this.caseUUID         = this.data.caseUUID;
  }

  ngOnInit(): void {
    this.fetchDocumentTypeCategories();
    console.log(this.aiVisionResult);
  }

  public closeDialog(value = null): void {
    this.dialogRef.close(value);
  }

  public confirmDocType(suggestedDocType: string): void {
    const data = {
      document_type: suggestedDocType
    }
    /* this.documentTypeService.changeDocumentType(this.case.id, data,)
       .subscribe({
         next:  result => {
           this.toast.success(this.translate.instant('SHARED.success'));
         },
         error: error => {
           this.toast.error(this.translate.instant('SHARED.error'));
         }
       });*/
  }

  protected fetchDocumentTypeCategories(): void {
    this.isLoading++;
    this.subscriptions.push(
      this.documentTypeService.indexCaseDocumentTypeCategories(this.caseUUID, {}, [])
        .pipe(finalize(() => this.isLoading--))
        .subscribe({
          next:  result => {
            this.caseDocumentTypeCategories = result.data;
            this.fileCategory               = this.caseDocumentTypeCategories.find(
              category => category.id === this.aiVisionResult.matched_doc_type_id
            );

            console.log(this.fileCategory, 'Matched Category');
          },
          error: err => {
          }
        })
    );
  }
}
